import type { AUTHENTICATION_INTENT, AUTHENTICATION_PROVIDERS } from '~/constants/authentication'

// Look into moving this to useAuthentication
export default function useLogin() {
  const authenticationModal = useAuthenticationModal()
  const authenticationType = useAuthenticationType()
  const authenticationIntent = useAuthenticationIntent()
  const { authenticationProvider } = useAuthentication()

  const intentCookie = useIntentCookie()
  const redirectCookie = useRedirectCookie()

  function showLogin(params?: {
    intent?: AUTHENTICATION_INTENT
    provider?: AUTHENTICATION_PROVIDERS // Only support email for now
    redirectTo?: string
  }) {
    const { intent, provider, redirectTo } = params ?? {}

    authenticationType.value = 'Login'
    authenticationIntent.value = intent
    authenticationProvider.value = provider
    authenticationModal.value = true

    intentCookie.value = intent ?? null

    if (redirectTo) {
      redirectCookie.value = redirectTo
    }
  }

  const isLoginVisible = computed(() => authenticationType.value === 'Login')

  return {
    isLoginVisible,
    showLogin,
  }
}
